import { Grid, Paper } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Api from "../../../../helpers/api";
import { getProjects, getProjectSampleAllData } from "../../store/actions";
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },

  })
);
interface Props {
  subProjectId: string
  projects: any;
  sampleAllData: any;
}
const StopsPlace: React.FC<Props> = ({
  subProjectId,
  projects,
  sampleAllData,
}) => {
  const classes = useStyles();
  const [projectSamples, setProjectSamples] = useState<any[]>([]);
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    if (subProjectId) {
      Api.get("/genomics/project-samples", { subProject: subProjectId }).then((data: any) => {
        setProjectSamples(data?.results);
      });
    }
  }, [subProjectId])

  //   const handleChangePage = (
  //     event: React.MouseEvent<HTMLButtonElement> | null,
  //     newPage: number
  // ) => {
  //     if (newPage > page) {
  //         let url = sampleAllData.links && sampleAllData.links.next.split("?")[1];
  //         getProjectSampleAllData(`?${url}`);
  //     } else if (newPage < page) {
  //         let url = sampleAllData.links && sampleAllData.links.previous.split("?")[1];
  //         getProjectSampleAllData(`${url === undefined ? "" : "?" + url}`);
  //     }
  //     setPage(newPage as number);
  // };

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid container style={{ marginTop: 10 }}>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "480px" }}
        >
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="center">
                  Sample Name
                </StyledTableCell>
                <StyledTableCell align="center">
                  Freezer Name
                </StyledTableCell>
                <StyledTableCell align="center">
                  Freezer No
                </StyledTableCell>
                <StyledTableCell align="center">
                  Box No
                </StyledTableCell>
                <StyledTableCell align="center">
                  Well No
                </StyledTableCell>
                <StyledTableCell align="center">
                  Rack No
                </StyledTableCell>
                <StyledTableCell align="center">
                  Sample Handover To
                </StyledTableCell>
                <StyledTableCell align="center">
                  Sample Storage Status
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  Action
                </StyledTableCell> */}
              </StyledTableRow>
            </TableHead>
            {/* dummy data  */}
            <TableBody>
              {projectSamples && projectSamples?.map((data: any, index: any) => {
                return (
                  <StyledTableRow key={data?._id} >
                    <StyledTableCell align="center">
                      {data?.name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.freezerName}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.freezerNo}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.boxId}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.wellId}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.rackNo}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.storage?.handoverTo}
                    </StyledTableCell>
                    <StyledTableCell align="center">

                    </StyledTableCell>
                    {/* <StyledTableCell align="center">
                      <Button
                          color="primary"
                          variant="contained"
                          fullWidth
                          onClick={() => {
                            // setSampleStorageData(data)
                            setValue(1)
                            setOnboardingActionType("Edit Samples Storage Qc")
                          }}
                        >
                          Edit
                        </Button>
                    </StyledTableCell> */}
                  </StyledTableRow>
                )
              })
              }
            </TableBody>
            {/* <TableFooter>
              <TablePagination
                rowsPerPageOptions={[]}
                colSpan={3}
                count={sampleAllData?.count || 0}
                rowsPerPage={sampleAllData?.page_size}
                page={page}
                onPageChange={handleChangePage}
              />
            </TableFooter> */}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,

});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,

})(StopsPlace);
